import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeftIcon } from "@heroicons/react/outline";
import CreateBranchForm from "../../components/Branch/forms/CreateBranchForm";

const CreateBranchPage = () => {
  const navigate = useNavigate();

  return (
    <div className="mx-auto sm:p-6 p-4">
      <button
        onClick={() => navigate("/branches")}
        className="flex items-center gap-2 text-gray-600 hover:text-gray-900 mb-4"
      >
        <ArrowLeftIcon className="h-4 w-4" />
        Back to Branches
      </button>

      <CreateBranchForm />
    </div>
  );
};

export default CreateBranchPage;
